import React, { useContext, useEffect, useState } from 'react'
import {
  AppSidebar,
  AppFooter,
  AppHeader,
  AppAside,
} from '../components/ui/template/index'
import { CContainer } from '@coreui/react-pro'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { LoaderContext } from '../components/loader/context/LoaderContext'
import { BASE_ROUTE } from '../../core/constants/route_name'
import ActionBar from '../components/actionBar/ActionBar'
import { StoreCleaner } from '../components'


const DefaultLayout = (): JSX.Element => {

  const navigate = useNavigate();
  const { handleLoading } = useContext(LoaderContext);

  const [isFullScreenRoute, setIsFullScreenRoute] = useState(false);
  const location = useLocation();

  const words = ['chat', 'calendario', 'calendar'];
  useEffect(() => {
    if (words.some(word => location.pathname.includes(word) && !location.pathname.includes("-"))) {
      setIsFullScreenRoute(true);
    } else {
      setIsFullScreenRoute(false);
    }
  }, [location.pathname])


  /**
   * Se ha hecho porque en el back cuando se devuelve el mensaje de token erróneo no tira
   * el usuario.
   */
  useEffect(() => {
    const interceptor = axios
      .interceptors
      .response.use(
        response => {



          // Comprueba si el mensaje es "Token erróneo" en una respuesta exitosa
          if (response.data.message === "Token erróneo") {
            handleLoading(false);
            // loguea el error y luego redirige al usuario a la página de login
            console.error(response);
            navigate('/login');
          }
          return response;
        },
        error => {

          // console.log('error', error)

          handleLoading(false);
          // loguea el error y luego redirige al usuario a la página de login
          console.error(error);
          const code = error?.response?.data?.item?.code;
          if (error.response?.status === 404) {
            return Promise.reject(error?.response);
          } else if (error.response?.status === 409
            && code) {
              console.log("CODE ERROR", code)
            //  No pasa nada. Ya se encarga el componente que lo recibe en actuar
            return Promise.reject(error?.response);
          } else {
            navigate('/login');
          }



        }
      );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);





  return (
    <>
      <AppSidebar />

      <div className="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
        <AppHeader />
        <div className={`body flex-grow-1 ${isFullScreenRoute ? 'p-0' : 'px-3'}`} style={{ position: 'relative' }}>
          <CContainer className={`${isFullScreenRoute ? 'p-0 m-0' : null}`}>
            <Outlet />
            <ActionBar />

            {/* Limpia el cache de los stores */}
            <StoreCleaner />


          </CContainer>
        </div>
        {isFullScreenRoute ? null : <AppFooter />}

      </div>

      {/* Pantalla lateral derecho */}
      <AppAside />
    </>
  )


}

export default DefaultLayout
